import SimpleModal from 'common/Form/Form';
import { Box, Grid, Tooltip, Typography, useMediaQuery } from '@mui/material';
import Card from 'common/Cards/CardDetailWithPricing';
import { useTranslation } from 'react-i18next';
import CardSummary from 'common/Cards/CardSummary';
import ComponentHeaderTwo from 'common/ComponentHeaderTwo/ComponentHeaderTwo';
import { ReactComponent as WorkOrder } from "assets/Modal/workorder.svg"
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { WorkOrderProfileService } from 'subModule/src/core/services';
import { GetWorkOrderByIdResponse } from 'subModule/src/services/workorder/interface';
import AlertMessages from 'common/Alert/AlertMessages';
import Loader from 'layout/Loader';
import PersonIcon from "@mui/icons-material/Person";
import { ReactComponent as Call } from "assets/Modal/call.svg";
import { brandingInfo } from 'features/server/brandingSlice';
import { useSelector } from 'react-redux';
import { themes } from 'theme/themes';
import { useBusinessSetupEntityBreadcrumbs } from 'Helpers/useBusinessSetupEntityBreadcrumbs';
export default function WorkOrderModal() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const { breadcrumbItems, captureLabel } = useBusinessSetupEntityBreadcrumbs({
        sectionLabelKey: 'customers',
        moduleLabelKey: 'workOrders',
        moduleHref: '/work-orders',
        entityFallbackLabelKey: 'workOrderNo',
        isEdit: !!params?.id,
        action: 'details',
    });
    const { enqueueSnackbar } = useSnackbar();
    const branding = useSelector(brandingInfo);
    const themeColors =
        branding?.attributes?.themeId === 100
          ? branding?.attributes?.customTheme
          : (themes as any)[branding?.attributes?.themeId || 3];
    const [loading, setLoading] = useState<boolean>(params?.id ? true : false);
    const [workOrder, setWorkOrder] = useState<any>({});
    const isScreen900pxOrGreater = useMediaQuery("(min-width:900px)");
    useEffect(() => {
        if (params?.id) {
            if (loading) getByID();
        }
    }, [params]);
    const getByID = () => {
        WorkOrderProfileService.getWorkOrderByID(+(params as any)?.id).then((res: GetWorkOrderByIdResponse) => {
            if (res.success) {
                setWorkOrder(res?.data || {});
                captureLabel(res?.data?.workOrderNo != null ? String(res.data.workOrderNo) : null);
                setLoading(false);
            } else {
                enqueueSnackbar(<AlertMessages text={res.message || "Something went wrong"} />, { variant: 'error' });
            }
        }).catch((err: any) => { console.error("===", err); });
    }

    return (
        <div>
            <ComponentHeaderTwo
                breadcrumbItems={breadcrumbItems}
                showBtn={true}
                showSaveBtn={false}
                onClick={() => navigate(-1)}
                onSubmit={() => { }}
                heading={t('workOrderDetails')}
                icon={<WorkOrder height={28} width={28} />}
                btnText={"back"}
                btnType={"back"}
                isBtnEnabled={false}
                showCreateBtn={false}
            />
            {loading ? <Loader /> : <SimpleModal
                visable={true}
                title={"workOrderDetails"}
                isButtonVisable={false}
                isVisableBtn={false}
                btnclosetext="Back"
                buttonText={""}
                attBtnNotshow={false}
                notVisableBackbtn={true}
                formSubmit={() => { }}
                content={<>
                    <Grid container sx={{
                        background: "#fff",
                        borderRadius: "8px",
                        margin: "10px 0",
                        padding: "6px 20px",
                    }}>
                        <Grid container xs={12} md={6}>
                            <Grid xs={12} sm={2}>
                                <img
                                    className="px-[8px] w-[90px] h-[90px] object-contain"
                                    src={
                                        workOrder?.attributes?.makeTitle
                                            ? `/vehicle-optimized-images/${workOrder?.attributes?.makeTitle
                                                .toLowerCase()
                                                .replace(/\s+/g, "-")}.png`
                                            : "/truck.png"
                                    }
                                    onError={(e) => (e.currentTarget.src = "/truck.png")}
                                />
                            </Grid>
                            <Grid container xs={12} sm={4}>
                                <Grid xs={12} className="text-left">
                                    <Typography className="font-Saira text-black font-[600] line-clamp-1 text-[14px]">
                                        {workOrder?.attributes?.makeTitle ? <>
                                            {workOrder?.attributes?.makeTitle}-
                                            {workOrder?.attributes?.modelTitle}
                                            {workOrder?.attributes?.year ? "-" + workOrder?.attributes?.year : ""}
                                        </> : t('N/A')}
                                    </Typography>
                                </Grid>
                                <Grid xs={12} className="text-left pr-5">
                                    <Tooltip title={workOrder?.vehiclePlateNo || t('N/A')}>
                                        <div
                                            className="h-[40px] border-2 rounded-md px-2 flex items-center justify-center bg-[#E5E5E5]"
                                            style={{ borderColor: themeColors?.primary }}
                                        >
                                            <Typography
                                                className="font-Saira line-clamp-1 font-[700] text-[12px]"
                                                sx={{ color: themeColors?.primary }}
                                            >
                                                <span>{workOrder?.vehiclePlateNo || t('N/A')}</span>
                                            </Typography>
                                        </div>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            <Grid container xs={12} sm={6} rowGap={1} className={`relative ${isScreen900pxOrGreater && "left-[32%]"}`}>
                                <Grid xs={12} className="text-left ">
                                    <Typography className={`font-Saira italic text-txt-color font-[400] text-[12px] flex gap-1 justify-end ${i18n?.language === 'ar' || i18n?.language === 'ur' ? 'flex-row-reverse' : 'flex-row'}`}>
                                        {t('workOrder')}
                                        <span> : </span>
                                        <span className="font-[700]">{workOrder?.workOrderNo}</span>
                                    </Typography>
                                </Grid>
                                <Grid container xs={12} rowGap={1} className="text-left">
                                    <Grid item container xs={8}>
                                        <Grid xs={12} sx={{ lineHeight: 0 }}>
                                            <Typography className="font-Saira flex italic text-txt-color font-[500] text-[11px] items-center ms-[-3px]">
                                                <PersonIcon className="mr-1 w-[15px] text-[#000]" />
                                                {" "}
                                                {workOrder?.attributes?.customerName || t('N/A')}
                                            </Typography>
                                        </Grid>
                                        <Grid container xs={12}>
                                            <Typography className="font-Saira flex italic text-txt-color font-[500] text-[11px]">
                                                <Call
                                                    height={"12px"}
                                                    className="mt-[2px] mr-1"
                                                    width={"12px"}
                                                />{" "}
                                                {workOrder?.attributes?.customerPhone || t('N/A')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={4}
                                        className={`font-Saira flex gap-2 justify-around items-center relative top-[-10px] ${i18n?.language === 'ar' || i18n?.language === 'ur' ? 'flex-row-reverse' : 'flex-row'}`}
                                    >
                                        <Typography className="italic text-txt-color font-[400] text-[12px]">{t("status")}</Typography>
                                        <span>:</span>
                                        <div className={(workOrder?.active ? "status-active" : "status-inactive") + " px-3 py-1 rounded-lg"}>
                                            <Typography className="text-[12px]">{workOrder?.active ? t("open") : (workOrder.status === 303 ? t("closed") : t('cancelled'))} </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sm={6}>
                            <Grid xs={12}>
                                <Box className={`font-Saira text-txt-color font-[500] text-[12px] flex gap-1 justify-self-end ${i18n?.language === 'ar' || i18n?.language === 'ur' ? 'flex-row-reverse' : 'flex-row'}`}>
                                    <span className="italic">{t("vehicleNumber")}</span>
                                    <span>:</span>
                                    <span className="font-Saira italic text-black font-[700]">{workOrder?.vehicleVin || t('N/A')}</span>
                                </Box>
                            </Grid>
                            <Grid container xs={12}>
                                <Grid xs={12} sm={6}></Grid>
                                <Grid xs={12} sm={6} className="text-right">
                                    <Grid xs={12}>
                                        <Box className={`font-Saira text-txt-color text-[9px] font-[500] flex gap-1 justify-self-end ${i18n?.language === 'ar' || i18n?.language === 'ur' ? 'flex-row-reverse' : 'flex-row'}`}>
                                            <span className="italic">{t("station")}</span>
                                            <span>:</span>
                                            <span className="font-[600]">{workOrder?.attributes?.stationName}</span>
                                        </Box>
                                    </Grid>
                                    <Grid xs={12}>
                                        <span className="font-Saira italic text-txt-color font-[500] text-[9px]">
                                            {t("createdAt") + ":"}
                                        </span>
                                        <span className="font-Saira text-txt-color font-[600] text-[11px] ml-2">
                                            {(() => {
                                                const date = new Date(workOrder?.createdAt);
                                                return isNaN(date.getTime())
                                                    ? "-"
                                                    : new Intl.DateTimeFormat(i18n.language, {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                        numberingSystem:
                                                            i18n.language === "ur" || i18n.language === "ar"
                                                                ? "arab"
                                                                : "latn",
                                                    }).format(date);
                                            })()}
                                        </span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        {/* {workOrder?.packages?.length === 0 &&
                            workOrder?.services?.length === 0 &&
                            workOrder?.items?.length === 0 ?
                            <Typography className="font-Saira text-black text-center font-[700] my-3  w-[100%] text-[16px] leading-[24px]">{t("No Details Found!")}</Typography> :
                            <> */}
                                {workOrder?.packages?.length > 0 &&
                                    <Grid item xs={12} className="mt-4 p-2 rounded-lg ml-2">
                                        <Typography className="font-Saira text-start text-black line-clamp-1 font-[600] mb-2  text-[16px] leading-[24px]" >
                                            {t("packageDetails")}
                                        </Typography>
                                        <Grid item xs={12}>
                                            <Card data={workOrder?.packages} type="package" />
                                        </Grid>
                                    </Grid>
                                }
                                {workOrder?.services?.length > 0 &&
                                    <Grid item xs={12} className="mt-4 p-2 rounded-lg ml-2">
                                        <Typography className="font-Saira text-start text-black line-clamp-1 font-[600] mb-2  text-[16px] leading-[24px]" >
                                            {t("serviceDetails")}
                                        </Typography>
                                        <Card data={workOrder?.services} type="service" />
                                    </Grid>
                                }
                                {workOrder?.items?.length > 0 &&
                                    <Grid item xs={12} className="mt-4 p-2 rounded-lg ml-2">
                                        <Typography className="font-Saira text-start text-black line-clamp-1 font-[600] mb-2 text-[16px] leading-[24px]" >
                                            {t("itemDetails")}
                                        </Typography>
                                        <Grid item xs={12}>
                                            <Card data={workOrder?.items} type="item" />
                                        </Grid>
                                    </Grid>
                                }
                                <CardSummary data={workOrder} />
                            {/* </>
                        } */}
                    </Grid>
                </>}
            />}
        </div>
    );
}